var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-col',{staticClass:"d-flex flex-column mh-100",style:(_vm.style),attrs:{"id":"sidebarContainer","cols":"4"}},[(_vm.appLoaded)?_c('SideBar',{staticClass:"vertical-scroll"}):_c('Spinner',{attrs:{"data-test":"loading-spinner"}}),_c('OrbVizLegal',{staticClass:"p-1 px-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }